window.addEventListener('DOMContentLoaded', function () {
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  const lottieAnimations = {};

  document.querySelectorAll('.ft-min-lottie [id^="lottie-"]').forEach(el => {
    const path = isDesktop ? el.dataset.lottieDesk : el.dataset.lottieMob;

    if (!path) return;

    lottieAnimations[el.id] = bodymovin.loadAnimation({
      container: el,
      path,
      renderer: 'svg',
      loop: false,
      autoplay: false
    });
  });

  document.querySelectorAll('.ft-min-lottie .states-btn').forEach(button => {
    const span = button.querySelector('span');
    const lottieEl = button
      .closest('.bottom')
      ?.querySelector('.ft-min-lottie [id^="lottie-"]');
    if (!lottieEl) return;

    const anim = lottieAnimations[lottieEl.id];
    if (!anim) return;

    button.addEventListener('click', () => {
      const state = span.dataset.state;

      if (state === 'replay') {
        anim.goToAndPlay(0, true);
        span.dataset.state = 'pause';
      } else if (state === 'play') {
        anim.play();
        span.dataset.state = 'pause';
      } else if (state === 'pause') {
        anim.pause();
        span.dataset.state = 'play';
      }

      anim.removeEventListener('complete', anim._onComplete);

      anim._onComplete = () => {
        if (['pause', 'play'].includes(span.dataset.state)) {
          span.dataset.state = 'replay';
        }
      };

      anim.addEventListener('complete', anim._onComplete);
    });
  });

  Object.entries(lottieAnimations).forEach(([id, anim]) => {
    if (!anim) return;

    const element = document.querySelector(`.ft-min-lottie #${id}`);
    const bottom = element.closest('.ft-min-lottie .bottom');
    const span = bottom.querySelector('.ft-min-lottie .states-btn span');

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach(entry => {
          const isVisible = entry.isIntersecting;

          if (isVisible) {
            if (anim._isCompleted) return;

            anim.play();
            span.dataset.state = 'pause';

            const onComplete = () => {
              anim._isCompleted = true;
              span.dataset.state = 'replay';
              observerInstance.unobserve(element);
              anim.removeEventListener('complete', onComplete);
            };

            anim.removeEventListener('complete', anim._onComplete);
            anim._onComplete = onComplete;
            anim.addEventListener('complete', onComplete);
          } else if (!anim._isCompleted) {
            anim.pause();
            span.dataset.state = 'play';
          }
        });
      },
      { threshold: 0.8 }
    );

    observer.observe(element);
  });
});
